export default "__VITE_ASSET__DzwGLYQI__"